(function() {
    'use strict';

    angular.module('vhols')

        .directive('cookieStatement', function() {
            return {
                link: function($scope) {
                    $scope.showStatement = (sessionStorage.getItem('statementClosed') === null);

                    $scope.close = function() {
                        sessionStorage.setItem('statementClosed', true);
                        $scope.showStatement = false;
                    };
                },
                templateUrl: 'template/directives/cookie-statement.html'
            };
        });
})();
